// Base path for public assets (correct for both dev at / and prod at /fely-beauty-saloon-dev/)
const publicPath = (process.env.PUBLIC_URL || "").replace(/\/$/, "") || "";

const asset = (path: string) =>
  publicPath ? `${publicPath}/${path}` : `/${path}`;

export const ImageContainer = {
  /* ********************************* Home page images *********************************  */
  TopLogoImage: asset("images/logo-white.svg"),
  HomeBannerImage: asset("images/banner-img.jpg"),
  HomeImageOne: asset("images/home-img-1.png"),
  HomeImageTwo: asset("images/home-img-2.png"),
  HomeSliderCatOne: asset("images/s-cat-1.jpg"),
  HomeSliderCatTwo: asset("images/s-cat-2.jpg"),
  HomeSliderCatThree: asset("images/s-cat-3.jpg"),
  HomeSliderCatFour: asset("images/s-cat-4.jpg"),
  HomeSliderCatFive: asset("images/s-cat-5.jpg"),
  HomeSliderCatSix: asset("images/s-cat-6.jpg"),
  HomePlayStore: asset("images/app-store.png"),
  HomeGooglePlay: asset("images/google-play.png"),
  FooterImage: asset("images/footer-bg.jpg"),
  DownloadAppImage: asset("images/download-img.png"),
  /* ********************************* Home page images *********************************  */

  /* ********************************* Comman for login and signup ********************************* */
  Logo: asset("images/logo.svg"),
  LogoWhite: asset("images/logo-white.svg"),
  EyeImage: asset("images/eye-hide.svg"),
  EyeView: asset("images/eye-view.svg"),
  /* ********************************* Comman for login and signup ********************************* */

  /* ************* Authour side bar images *************  */
  AuthorSidebarImage: asset("images/author-img.jpg"),
  LogoSimbelImage: asset("images/logo-simbel.svg"),
  //   LogoSimbelImageSec: asset("images/logo-simbelSec.svg"),
  /* ************* Authour side bar images *************  */

  ProfileDetailBannerImage: asset("images/profie-detail-banner-img.jpg"),
  ProfileDetailIconImage: asset("images/profile-detail-img.jpg"),

  /* Model Boxes */
  LogoIconColor: asset("images/logo-icon-color.svg"),

  /*Not foun */
  NotFoundImage: asset("images/not-found.png"),

  AboutImg: asset("images/about_img.jpg"),

  profImg: asset("images/prof-img.png"),
  USERIMAGE: asset("images/USER_NEW.png"),
};
